<div class="card main-food-orders-card container-fluid">
  <div class="module-header">
    <h3 class="module-title m-0">{{ titulo }}</h3>
    <p class="module-subtitle m-0">Consulta de pedidos entregados, cancelados, rechazados y expirados</p>

    <div class="filters-toolbar">
      <div class="filter-group">
        <span class="filter-label">Rango de fechas</span>
        <div class="date-range">
          <p-calendar
            [(ngModel)]="dateStart"
            [showIcon]="true"
            inputId="dateStart"
            ariaLabel="Fecha inicio"
            [showOnFocus]="false"
            appendTo="body"
            dateFormat="dd-mm-yy"
            styleClass="date-range-input"
            (onSelect)="onDateChange()"
          />
          <i class="pi pi-arrow-right date-range-sep"></i>
          <p-calendar
            [(ngModel)]="dateEnd"
            [showIcon]="true"
            inputId="dateEnd"
            ariaLabel="Fecha fin"
            [showOnFocus]="false"
            appendTo="body"
            dateFormat="dd-mm-yy"
            styleClass="date-range-input"
            (onSelect)="onDateChange()"
          />
        </div>
      </div>

      <div class="filter-group">
        <span class="filter-label">Estado</span>
        <p-dropdown
          [options]="statusOptions"
          [(ngModel)]="selectedStatusId"
          optionLabel="label"
          optionValue="value"
          placeholder="Filtrar por estado"
          (onChange)="onStatusChange()"
        ></p-dropdown>
      </div>

      <p-button
        class="filters-refresh"
        label="Actualizar"
        icon="pi pi-refresh"
        severity="secondary"
        [outlined]="true"
        pTooltip="Actualizar Lista"
        (onClick)="loadOrders()"
      />
    </div>
  </div>

  <p-table [value]="orders" styleClass="p-datatable-striped p-datatable-sm" [paginator]="true" [rows]="15" responsiveLayout="scroll">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 110px;">Orden N°</th>
        <th>Fecha</th>
        <th>Cliente</th>
        <th>Subtotal</th>
        <th>Envío</th>
        <th>Total</th>
        <th>Estado</th>
        <th style="width: 80px;"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-order>
      <tr>
        <td class="font-bold">{{ formatOrderCode(order.orderId) }}</td>
        <td>
          <div class="cell-with-icon">
            <span class="icon-badge icon-badge--date"><i class="pi pi-calendar"></i></span>
            <span>{{ order.createdAt | date: 'dd/MM/yyyy HH:mm' }}</span>
          </div>
        </td>
        <td>
          <div class="customer-cell">
            <div class="cell-with-icon">
              <span class="icon-badge icon-badge--user"><i class="pi pi-user"></i></span>
              <span>{{ order.customerName }}</span>
            </div>
            <div class="cell-with-icon">
              <span class="icon-badge icon-badge--phone"><i class="pi pi-phone"></i></span>
              <span>{{ order.customerPhone }}</span>
            </div>
          </div>
        </td>
        <td>{{ order.subtotal | currency }}</td>
        <td>{{ order.deliveryFee | currency }}</td>
        <td><strong>{{ order.total | currency }}</strong></td>
        <td>
          <p-tag
            [value]="getStatusConfig(order)?.name ?? order.statusName"
            [style]="{ 'background-color': getStatusConfig(order)?.color }"
          ></p-tag>
        </td>
        <td>
          <p-button
            icon="pi pi-eye"
            [rounded]="true"
            [text]="true"
            severity="secondary"
            pTooltip="Ver detalle"
            tooltipPosition="top"
            [routerLink]="['/admin/food-orders/detail', order.orderId]"
          />
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8" class="text-center">No hay pedidos en el historial</td>
      </tr>
    </ng-template>
  </p-table>
</div>
